module.exports = __webpack_public_path__ + "img/ir.ir7fdcd50.svg";